import { useMutation } from '@tanstack/react-query';
import { authService } from 'shared/src/api';

export const usePostVerificationIssue = () => {
  return useMutation({
    mutationFn: authService.postVerificationIssue,
    throwOnError: false,
  });
};
